export const CLIENT_KANBAN_COLUMNS = [
  {
    id: "prospect",
    title: "Prospect",
    status: "Prospect",
    color: "#facc15",
    softClassName: "bg-yellow-100",
  },
  {
    id: "prospect-contacte",
    title: "Prospect Contacté",
    status: "Prospect Contacté",
    color: "#facc15",
    softClassName: "bg-yellow-100",
  },
  {
    id: "prospects-mairies",
    title: "Prospects Mairies",
    status: "Prospects Mairies",
    color: "#c084fc",
    softClassName: "bg-violet-100",
  },
  {
    id: "recontacte-attente",
    title: "Recontacté & attente",
    status: "Recontacté & attente",
    color: "#f9a8d4",
    softClassName: "bg-pink-100",
  },
  {
    id: "devis-envoyes",
    title: "Devis envoyés",
    status: "Devis envoyés",
    color: "#a7f3d0",
    softClassName: "bg-emerald-100",
  },
  {
    id: "en-test",
    title: "En Test",
    status: "En Test",
    color: "#c084fc",
    softClassName: "bg-violet-100",
  },
  {
    id: "devis-signes",
    title: "Devis signés & attente règlements",
    status: "Devis signés & attente règlements",
    color: "#a7f3d0",
    softClassName: "bg-emerald-100",
  },
  {
    id: "clients-mac",
    title: "Clients MAC",
    status: "Clients MAC",
    color: "#fde047",
    softClassName: "bg-yellow-100",
  },
  {
    id: "clients-mairies",
    title: "Clients Mairies",
    status: "Clients Mairies",
    color: "#fde047",
    softClassName: "bg-yellow-100",
  },
  {
    id: "clients-SAAS",
    title: "Clients SAAS",
    status: "Clients SAAS",
    color: "#fde047",
    softClassName: "bg-yellow-100",
  },
  {
    id: "perdu",
    title: "Perdu",
    status: "Perdu",
    color: "#fecaca",
    softClassName: "bg-red-100",
  },
];

export const DEFAULT_PRODUCT_OPTIONS = [
  "MonAppliClub Standard",
  "MonAppliClub Light",
  "MonAppliTournoi",
  "MonAppliComité",
  "MonAppliLigue",
  "MonAppliAsso",
  "MonAppliMairie",
  "MonAppliBénévoles",
  "MonAppliConformité",
  "Judo Coach Pro",
  "Judo Présence Pro",
  "Website",
  "Application spécifique",
  "Autre",
];

export const CLIENT_FAVORITE_OPTIONS = [
  { value: "all", label: "Tous" },
  { value: "true", label: "Favoris uniquement" },
];

export const CLIENT_SORT_OPTIONS = [
  { value: "position", label: "Ordre Kanban" },
  { value: "relance_asc", label: "Relance la plus proche" },
  { value: "relance_desc", label: "Relance la plus lointaine" },
];

export const EMPTY_CLIENT_STATS = {
  total: 0,
  prospects: 0,
  tests: 0,
  clients: 0,
  relances: 0,
};